import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal-ontologies.vue?vue&type=template&id=c0fea802&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal-ontologies.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal-ontologies.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal-ontologies.scss?vue&type=style&index=0&id=c0fea802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fea802",
  null
  
)

export default component.exports